import { type ReactNode } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from '@mondivago/supabase';
import { ToastProvider } from '@/components/ui/Toast';
import { StripeProvider } from '@/shared/context/StripeContext';
import { CurrencyProvider } from '@/shared/context/CurrencyContext';

interface AppProvidersProps {
  /** Pass BrowserRouter (client) or StaticRouter (server render) */
  router: ReactNode;
  /** Optional helmet context object — only needed for server-side rendering */
  helmetContext?: object;
}

/**
 * Shared provider tree for both the client entry and the server entry.
 * The router is injected as a prop so the server entry can use StaticRouter
 * while the browser entry uses BrowserRouter — without duplicating the tree.
 */
export function AppProviders({ router, helmetContext = {} }: AppProvidersProps) {
  return (
    <HelmetProvider context={helmetContext}>
      <AuthProvider>
        <StripeProvider>
          <CurrencyProvider>
            <ToastProvider>{router}</ToastProvider>
          </CurrencyProvider>
        </StripeProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}
